export const queryKeys = {
  organization: "org-config",
  webConfig: "web-config",
  strings: "web-strings",
  stripeObject: "stripe-object",
  squareObject: "square-object",
} as const;
